module.exports = __webpack_public_path__ + "static/media/thumbnail.907ff9fb.jpg";